import {StockMovementEditor} from "./CreateOpeningStock.jsx";
export default function AddNewPrdSrvc(props){return <StockMovementEditor {...props} kind="execution"/>;}
